import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { getFamilyList } from '../../organisms-cms/child-bio/utils/familyList.tsx';
import { listFormat } from '../../organisms-cms/child-bio/utils/simpleList.tsx';
import { getAge } from '../../utils/child-bio.ts';
type ChildBioSummaryBaseProps = {
  details: ChildDetails;
  translatedCountry: string;
  className?: string;
};
type ChildBioSummaryShortProps = ChildBioSummaryBaseProps & {
  short: true;
  translatedLanguage?: never;
};
type ChildBioSummaryLongProps = ChildBioSummaryBaseProps & {
  short?: false | undefined;
  translatedLanguage: string;
};
export type ChildBioSummaryProps = ChildBioSummaryShortProps | ChildBioSummaryLongProps;
export const ChildBioSummary = t0 => {
  const $ = _c(18);
  const {
    className: t1,
    details,
    translatedCountry,
    translatedLanguage,
    short: t2
  } = t0;
  const className = t1 === undefined ? "mb-comfy-sm" : t1;
  const short = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["bio"];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    t
  } = useTranslation(t3);
  let t4;
  let t5;
  if ($[1] !== className || $[2] !== details.ageInYearsAndMonths || $[3] !== details.gender || $[4] !== details.hangul.preferred || $[5] !== details.householdList[0].householdMemberList || $[6] !== details.interests.favoriteProjectActivity || $[7] !== details.interests.thingsILike || $[8] !== details.name.preferred || $[9] !== short || $[10] !== t || $[11] !== translatedCountry || $[12] !== translatedLanguage) {
    const age = getAge(details.ageInYearsAndMonths);
    const favoriteActivities = details.interests.thingsILike.length > 0 ? t("bio:favoriteActivities", {
      context: details.gender,
      favorites: listFormat(short ? details.interests.thingsILike.slice(0, 3) : details.interests.thingsILike)
    }) : "";
    const projectActivities = details.interests.favoriteProjectActivity.length > 0 ? t("bio:projectActivities", {
      context: details.gender,
      activities: listFormat(details.interests.favoriteProjectActivity)
    }) : "";
    t4 = className;
    t5 = t(short ? "bio:summaryShort" : "bio:summary", {
      context: details.gender,
      childName: details.name.preferred,
      koreanName: details.hangul.preferred || details.name.preferred,
      age,
      country: translatedCountry,
      family: getFamilyList(details.householdList[0].householdMemberList),
      favoriteActivities,
      projectActivities,
      ...(short ? {} : {
        language: translatedLanguage
      }),
      interpolation: {
        escapeValue: false
      }
    });
    $[1] = className;
    $[2] = details.ageInYearsAndMonths;
    $[3] = details.gender;
    $[4] = details.hangul.preferred;
    $[5] = details.householdList[0].householdMemberList;
    $[6] = details.interests.favoriteProjectActivity;
    $[7] = details.interests.thingsILike;
    $[8] = details.name.preferred;
    $[9] = short;
    $[10] = t;
    $[11] = translatedCountry;
    $[12] = translatedLanguage;
    $[13] = t4;
    $[14] = t5;
  } else {
    t4 = $[13];
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};